export const QUERY_REFERRAL_CODE = 'refid'; // 分享链接的 url query
export const STORAGE_REFERRAL = 'referral'; //storage key
export const CODE_VALID_DURATION = 2592000000;//Referral Code 有效期30天 30*24*60*60*1000
export const LOAD_PAGE_ACTION = 'desiredAction'; // 加载页面判断要执行的动作

// refer a friend 进入过页面
export const COOKIE_ENTERED_REFER_A_FRIEND = 'ENTERED_REFER_A_FRIEND'